import { RelatedProperties, StringRelatedPropertyValue } from '@models/api-search.models';

const sortingOrder: (keyof RelatedProperties)[] = ['primaryColor'];

export const keyValueSort = (a: StringRelatedPropertyValue) => (a?.key === sortingOrder[0] ? -1 : 1);
